const validators = {
    price: (p, t) => {
        //console.log("validate price", p, t)
        if (t?.keys?.amount?.decimals !== 2) return false
        if (typeof p?.amount !== "number" || isNaN(p?.amount)) return false
        return true
    },
}
export default validators
